import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import type { Location } from '@/types/scriptAnalysis';
import { getConfidenceLevel } from '@/types/scriptAnalysis';

interface LocationListProps {
  locations: Location[];
}

const confidenceConfig = {
  high: {
    label: 'Alta',
    className: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-950 dark:text-emerald-400 border-transparent',
  },
  medium: {
    label: 'Media',
    className: 'bg-amber-50 text-amber-600 dark:bg-amber-950 dark:text-amber-400 border-transparent',
  },
  low: {
    label: 'Baja',
    className: 'bg-red-50 text-red-600 dark:bg-red-950 dark:text-red-400 border-transparent',
  },
};

export function LocationList({ locations }: LocationListProps) {
  return (
    <TooltipProvider>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead scope="col">Localizacion</TableHead>
            <TableHead scope="col">Variantes</TableHead>
            <TableHead scope="col">Escenas</TableHead>
            <TableHead scope="col">Confianza</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {locations.map((location) => {
            const level = getConfidenceLevel(location.confidence);
            const conf = confidenceConfig[level];
            const variantCount = location.variants?.length ?? 0;

            return (
              <TableRow key={location.id}>
                <TableCell>
                  <div>
                    <span className="font-medium">{location.name}</span>
                    {variantCount > 0 && (
                      <p className="text-xs text-muted-foreground mt-1">
                        {location.variants!.map(v => v.name).join(', ')}
                      </p>
                    )}
                  </div>
                </TableCell>
                <TableCell>
                  {variantCount > 0 ? (
                    <Badge variant="secondary">{variantCount}</Badge>
                  ) : (
                    <span className="text-muted-foreground">-</span>
                  )}
                </TableCell>
                <TableCell>{location.scene_count ?? '-'}</TableCell>
                <TableCell>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Badge className={conf.className}>
                        {conf.label}
                      </Badge>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>
                        Confianza de la IA: {(location.confidence * 100).toFixed(0)}% - Los elementos marcados como borrador requieren revision manual.
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TooltipProvider>
  );
}
